import { useStores } from "../../core/stores/rootStore";
import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from 'react-router-dom';
import { observer } from "mobx-react";
import { useTranslation, Trans } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { solid, regular } from "@fortawesome/fontawesome-svg-core/import.macro";
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import Button from 'react-bootstrap/Button';
import Stack from 'react-bootstrap/Stack';
import Modal from 'react-bootstrap/Modal';
import Container from 'react-bootstrap/Container';
import Card from 'react-bootstrap/Card';
import Form from 'react-bootstrap/Form';
import Table from 'react-bootstrap/Table';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Badge from 'react-bootstrap/Badge';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import { prepareForm, getFullName, formatDateTime } from "./../../utils";
import FormText from './../inputs/text';
import { publish, subscribe } from "./../../events";

const TimesheetHeaderItem = (props) => {

    let navigate = useNavigate();
    const { usersAdminStore, loginStore,timesheetStore ,utilsStore} = useStores();
    const { t, i18n } = useTranslation();
    const { ignoreMessage, setInformation } = usersAdminStore;
    const { updateDate } = timesheetStore;
    

    const getKey = () => `${props.month.developer?.id}_${props.month.month}_${props.month.year}`;
    const handleClick = (e) => {
        
        navigate(`/timesheets/${getKey()}`, { replace: true, state: { month: props.month } });
    }

    const [showMessage, setShowMessage] = useState(false);

    const getStatuses = (month) => {
        return month?.devMonthStatus ?? null;
    }

    const [showEditInfo, setShowEdit] = useState(false);
    const [fields, setFields] = useState({});
    
    
    const handleInfoSubmit = (event) => {
        event.preventDefault();
        const form = event.currentTarget;

        if (form.checkValidity() === false) {
            event.preventDefault();
            event.stopPropagation();
        } else {
            const formData = prepareForm(event, false, ["id"]);

            if (fields.isUserInfo) {
                setInformation(formData).then(() => {
                    setShowEdit(false);
                    //props.month.developer.information = formData.message;
                    props?.onUpdateUser?.({ id: formData.id, data: formData.message });
                })                
            } else {
                updateDate(getKey(), 6, formData.message).then(() => {
                    setShowEdit(false);
                    props.month.devMonthStatus.information = formData.message;
                });               
            }

        }

    };

    function getInternalExpensesStatus(status) {
        switch (status) {
            case 0:
                return <div style={{ marginLeft: '10px' }}>
                    <FontAwesomeIcon className="mx-1" icon={solid("spinner")} />
                    <b> {t('initial')}</b>
                </div>;
            case 1:
                return <div style={{ marginLeft: '10px' }}>
                    <FontAwesomeIcon className="mx-1" icon={solid("spinner")} />
                    <b> {t('pendingForApproval')}</b>
                </div>;
            case 2:
                return <div style={{ marginLeft: '10px' }}>
                    <FontAwesomeIcon className="mx-1" icon={regular("circle-check")} />
                    <b> {t('validated')}</b>
                </div>;
            case 3:
                return <div style={{ marginLeft: '10px' }}>
                    <FontAwesomeIcon className="mx-1" icon={solid("ban")} />
                    <b> {t('rejected')}</b>
                </div>;
            default:
                return <span>-</span>;
        }
    }


    return (
        <div>
            <Modal show={showMessage} onHide={() => setShowMessage(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>{t("message")}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Stack gap={2}>
                        <span>{props?.month?.developer?.name} {props?.month?.developer?.surname} {t("messageReceived")}</span>
                        <span style={{ whiteSpace: "pre-line" }}><i>{props?.month?.developer?.message}</i></span>
                    </Stack>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={(e) => {                        
                        setShowMessage(false)
                    }}>{t("ok")}</Button>
                    <Button variant="primary" onClick={(e) => {
                        
                        ignoreMessage(props?.month?.developer?.id).then(() => {
                            props.month.developer.message = null;
                            setShowMessage(false);
                            publish("messageIgnored");
                        });

                    }}>{t("ignore")}
                    </Button>
                </Modal.Footer>
            </Modal>

            <Modal show={showEditInfo} onHide={() => setShowEdit(false)}>
                <Form noValidate onSubmit={handleInfoSubmit}>
                    <Modal.Header closeButton>
                        <Modal.Title>{t(fields?.isUserInfo?"editUserInformation":"editInformation")}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Stack gap={2}>
                            <FormText id="id" hidden object={fields} />
                            <FormText autoFocus lines={5} label={t("information")} id="message" object={fields} />
                        </Stack>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" type="submit" /*onClick={() => { alert("dsa") }}*/>
                            {t("save")}
                        </Button>
                    </Modal.Footer>
                </Form>
            </Modal>

            <div className="border rounded p-2" style={{ backgroundColor: "white", cursor: "pointer" }} onClick={handleClick}>
                <Row>
                    <Col>
                        <Stack gap={0}>
                            <Stack direction="horizontal" gap={2}>
                                <b>{props?.month?.developer?.username?.toUpperCase()}</b>
                                {!props.ignoreMessage && props?.month?.developer?.message && <Button className="p-0" variant="secondary" size="sm" onClick={(e) => {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    setShowMessage(true);
                                }}><FontAwesomeIcon className="mx-1" icon={solid("comment")} size="1x" /></Button>}
                                
                            </Stack>
                            <span>{getFullName(props?.month?.developer)}</span>
                            <span>{props?.month?.project?.name}</span>                            
                            
                            <span title={t("clickToEdit")} onClick={(e) => {
                                e.preventDefault();
                                e.stopPropagation();
                                setFields({ id: props.month?.developer?.id, message: props?.month?.developer?.information, isUserInfo: true });
                                setShowEdit(true);
                            }}
                                style={{
                                    padding: "0px 8px",
                                    height: "100%",
                                border: "1px solid lightGray", fontSize: "13px", backgroundColor:"#f9f9f9"
                                }}>
                                    <span style={{ whiteSpace: "pre-line" }} title={t("clickToEdit")}>
                                        {props?.month?.developer?.information ? props?.month?.developer?.information : (<i>{t("noUserInfo")}</i>)}
                                    </span>
                                </span>
                            

                        </Stack>
                    </Col>
                    <Col>
                        <Stack>
                            <span><Badge className="mx-1" bg="secondary">{props?.month?.pendingConsultantCount ?? 0}</Badge>{t("pendingConsultant")}</span>
                            <span><Badge className="mx-1" bg="secondary">{props?.month?.pendingValidationCount ?? 0}</Badge>{t("pendingValidation")}</span>
                            <span><Badge className="mx-1" bg="secondary">{props?.month?.rejectedCount ?? 0}</Badge>{t("rejected")}</span>
                            <span><Badge className="mx-1" bg="secondary">{props?.month?.validatedCount ?? 0}</Badge>{t("validatedByClient")}</span>
                            <span><Badge className="mx-1" bg="secondary">{props?.month?.adminValidatedCount ?? 0}</Badge>{t("validated")}</span>
                            <span><Badge className="mx-1" bg="secondary">{props?.month?.billedCount ?? 0}</Badge>{t("billed")}</span>
                        </Stack>
                    </Col>

                    <Col>
                        <Stack>
                            <Stack direction="horizontal" gap={2}><Form.Check disabled type="checkbox" checked={getStatuses(props.month)?.billed ?? false} />{t("billing")}: {(getStatuses(props.month)?.billed ? formatDateTime(new Date(getStatuses(props.month)?.billed)) : "-")}</Stack>
                            <Stack direction="horizontal" gap={2}><Form.Check disabled type="checkbox" checked={getStatuses(props.month)?.sent ?? false} />{t("sentDownloaded")}: {(getStatuses(props.month)?.sent ? formatDateTime(new Date(getStatuses(props.month)?.sent)) : "-")}</Stack>
                            <Stack direction="horizontal" gap={2}><Form.Check disabled type="checkbox" checked={getStatuses(props.month)?.winbizSync ?? false} />{t("winbizSynced")}: {(getStatuses(props.month)?.winbizSync ? formatDateTime(new Date(getStatuses(props.month)?.winbizSync)) : "-")}</Stack>
                            <Stack direction="horizontal" gap={2}><Form.Check disabled type="checkbox" checked={getStatuses(props.month)?.salarySync ?? false} />{t("salarySynced")}: {(getStatuses(props.month)?.salarySync ? formatDateTime(new Date(getStatuses(props.month)?.salarySync)) : "-")}</Stack>
                            <Stack direction="horizontal" gap={2}><Form.Check disabled type="checkbox" checked={getStatuses(props.month)?.expense ?? false} />{t("expense")}: {(getStatuses(props.month)?.expense ? formatDateTime(new Date(getStatuses(props.month)?.expense)) : "-")}</Stack>
                            <Stack direction="horizontal" gap={2}>
                                <span style={{ width: '1em' }}></span>
                                {t("internalExpensesStatus")} : 
                                {getInternalExpensesStatus(props?.month?.internalExpensesStatus)}
                            </Stack>

                        </Stack>
                    </Col>


                    <Col>

                        <Stack direction="horizontal">

                            <span style={{ whiteSpace: "pre-line" }} title={t("clickToEdit")}
                                onClick={(e) => {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    setFields({ id: props.month?.developer?.id, message: props?.month?.devMonthStatus?.information, isUserInfo: false });
                                    setShowEdit(true);
                                }}

                            >{props?.month?.devMonthStatus?.information ? props?.month?.devMonthStatus?.information : (<i>{t("none")}</i>)}</span>
                        </Stack>
                    </Col>      
                    
                    <Col>
                        
                        <Stack>
                            <div style={{ alignSelf: "end" }}>
                                <Button style={{marginRight:20}} variant="secondary" onClick={(e) => {
                                    e.preventDefault();
                                    e.stopPropagation();

                                    props.onMessage?.();
                                    /*setEmailValidated(false);
                                    setShowEmail(true);*/
                                }}><FontAwesomeIcon icon={solid("envelope")} /></Button>
                                {t("currentStatus")}: {t(props?.month?.devMonthStatus?.finished ? "finished" : "open")}
                            </div>
                        </Stack>
                    </Col>

                </Row>
            </div>
        </div>
    );
};

export default observer(TimesheetHeaderItem);
